export default {
    categories:[],
    questionsAnswers: [] ,
    categorySelected: null,         
    query: '',
    isLoadingQuestions: false
              
}